import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
    DotsThreeOutlineVertical, Share, Star,
} from '@phosphor-icons/react';
import Button from '../../../common/button/Button';
import Sharing from '../../../common/sharing/Sharing';
import Rating from '../containers/RatingContainer';

class MenuMobileComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openMenu: false,
            showRating: false,
            showSharing: false,
            ratingVisibility: 'hidden',
            sharingVisibility: 'hidden',
            // This state is needed to hide the menuOption on first page load, otherwise it will start scrolling down until be hidden
            menuOptionDisplay: 'none',
        };
    }

    render() {
        if (!this.props.isMobile) {
            return false;
        }

        const menuIsOpened = this.state.openMenu ? 'menuOptionOpened' : 'menuOptionClosed';
        const sharingIsOpened = this.state.showSharing ? 'subMenuItemOpened' : 'subMenuItemClosed';
        const ratingIsOpened = this.state.showRating ? 'subMenuItemOpened' : 'subMenuItemClosed';
        const closeSubMenu = !this.state.openMenu ? 'subMenuClosed' : '';

        const artist = this.props.artist || 'Antena 1';
        const isNoMusic = this.props.metaType !== 'music';
        const song = this.props.song || 'A Rádio Online mais ouvida do Brasil';
        const title = isNoMusic ? 'o melhor do mundo da música' : `${song} de ${artist}`;
        const titleToShare = `Eu estou ouvindo ${title} na Antena 1`;
        const artistHashtag = isNoMusic ? '' : artist.replace(' ', '');

        return (
            <div className="menuMobile">
                <Button
                    title="Abrir menu"
                    className="btnOpenMenu"
                    onClick={() => this.setState((prevState) => ({
                        openMenu: !prevState.openMenu,
                        showRating: false,
                        showSharing: false,
                        menuOptionDisplay: 'flex',
                    }))}
                >
                    <DotsThreeOutlineVertical size={15} weight="fill" />
                </Button>
                <div className="openMenu">
                    <ul className={`menuOption ${menuIsOpened}`} style={{ display: this.state.menuOptionDisplay }}>
                        <Button title="Compartilhar" onClick={() => this.setState((prevState) => ({ showSharing: !prevState.showSharing, sharingVisibility: 'visible' }))}>
                            <li className="tw-flex tw-items-center tw-justify-center">
                                <Share size={15} weight="fill" />
                            </li>
                        </Button>
                        <Button title="Votar na música" onClick={() => this.setState((prevState) => ({ showRating: !prevState.showRating, ratingVisibility: 'visible' }))}>
                            <li className="tw-flex tw-items-center tw-justify-center">
                                <Star size={15} weight="fill" />
                            </li>
                        </Button>
                    </ul>
                    <ul className={`subMenu ${closeSubMenu}`}>
                        <li
                            className={`subMenuItem ${sharingIsOpened}`}
                            // style prop needed to hide the display on initial pageload
                            style={{
                                visibility: this.state.sharingVisibility,
                            }}
                        >
                            <Sharing
                                path="/ouvir-radio-online"
                                iconSize={15}
                                widthBlockIcon={34}
                                shareButtonsTo={['facebook', 'twitter', 'whatsapp']}
                                facebook={{ quote: titleToShare, hashtag: '#Antena1' }}
                                twitter={{ title: titleToShare, hashtags: [artistHashtag, 'Antena1'] }}
                                whatsapp={{ title: titleToShare }}
                            />
                        </li>
                        <li
                            className={`subMenuItem ${ratingIsOpened}`}
                            // style prop needed to hide the display on initial pageload
                            style={{
                                visibility: this.state.ratingVisibility,
                            }}
                        >
                            <Rating />
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

MenuMobileComponent.propTypes = exact({
    artist: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    song: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    metaType: PropTypes.string,
    isMobile: PropTypes.string,
});

export default MenuMobileComponent;
